var _desc, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "69px",
    height: "56px",
    viewBox: "0 0 69 56",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Lunacy")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.6997 56C47.7387 56 61.9784 34.4574 61.9784 15.7765C61.9784 15.1646 61.966 14.5555 61.9385 13.9491C64.7026 11.9536 67.1051 9.46338 69 6.62858C66.4635 7.7545 63.7338 8.51245 60.8704 8.85422C63.7931 7.10402 66.037 4.33543 67.0956 1.03495C64.3604 2.65423 61.3314 3.83113 58.1063 4.46653C55.523 1.71868 51.8452 0 47.7728 0C39.9551 0 33.6155 6.33112 33.6155 14.1351C33.6155 15.2445 33.7397 16.3236 33.9826 17.3586C22.2169 16.7674 11.7839 11.1419 4.80157 2.58808C3.5858 4.67727 2.88476 7.10409 2.88476 9.69356C2.88476 14.5983 5.38401 18.9281 9.18451 21.4612C6.86193 21.3895 4.68013 20.7528 2.77316 19.6931C2.77108 19.7524 2.77108 19.8102 2.77108 19.8736C2.77108 26.7201 7.65079 32.4364 14.1284 33.7317C12.9388 34.0556 11.6872 34.2292 10.3955 34.2292C9.48468 34.2292 8.59733 34.1397 7.73484 33.9743C9.5371 39.5914 14.7632 43.6789 20.9593 43.7932C16.1141 47.5857 10.0104 49.8445 3.37679 49.8445C2.23552 49.8445 1.10808 49.7797 0 49.6488C6.26525 53.6591 13.7046 55.9991 21.7004 55.9991",
    id: "Path",
    fill: "#252D38",
    stroke: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.b254a76df106cc45afabfecbcf706a07.svg";
export { ForwardRef as ReactComponent };